export const MODE_APPOINTMENT = 'OAR';
export const MODE_CONTACT = 'Contact form';

export const PRESCREENER_CLIENT_TYPES = {
  client: 'client',
  partner: 'partner',
  contact: 'contact',
};

const couple = [PRESCREENER_CLIENT_TYPES.client, PRESCREENER_CLIENT_TYPES.partner];
const contact = [PRESCREENER_CLIENT_TYPES.client, PRESCREENER_CLIENT_TYPES.contact];
const client = [PRESCREENER_CLIENT_TYPES.client];

export const CLIENTS_FOR_CLIENT_TYPE_SELECTION = {
  Client: client,
  ClientCouple: couple,
  ClientContact: contact,
  client,
  couple,
  contact,
};

export const CLIENT_TYPES = [
  { type: 'client', label: 'booking.clientType.me' },
  { type: 'couple', label: 'booking.clientType.couple' },
  { type: 'contact', label: 'booking.clientType.contact' },
];

export const CLIENT_TYPES_FOR_CARE_COORDINATOR = [
  { type: 'client', label: 'booking.clientType.careCoordinator.member' },
  { type: 'couple', label: 'booking.clientType.careCoordinator.memberAndPartner' },
  { type: 'contact', label: 'booking.clientType.careCoordinator.memberOnBehalf' },
];

export const QUESTION_TYPES = {
  MULTISELECT: 'multiselect',
  STRING: 'string',
  TEXT: 'text',
  FILE: 'file',
  SELECT: 'select',
  DATE: 'date',
};

export const QUESTION_NAMES = {
  INSURANCE_CARD_UPLOAD: 'insurance_card_upload',
  PREFERRED_CLINICIAN: 'preferred_clinician',
  DRIVERS_LICENSE: 'drivers_license',
  DATE_OF_BIRTH: 'date_of_birth',
  NICKNAME: 'nickname',
  GENDER: 'gender',
  STATE: 'state',
  SEX: 'sex',
};

const SIDES = ['front', 'back'];
const ONE_SIDE = SIDES.slice(0, 1);

export const DOCUMENT_SIDES = {
  [QUESTION_NAMES.INSURANCE_CARD_UPLOAD]: SIDES,
  [QUESTION_NAMES.DRIVERS_LICENSE]: ONE_SIDE,
  DEFAULT: ONE_SIDE,
};

export const LENGTH_LIMITS = {
  TEXT_AREA_MAX: 600,
};

export const FAKE_PREFIXES = {
  CLINICIAN: 'fake-clinician',
  OFFICE: 'fake-office',
  CPT_CODE: 'fake-code',
  RESERVATION: 'fake-reservation',
};

export const PRESCREENER_CATEGORIES = {
  REASON_FOR_CARE: 'reason for care',
  BILLING_PAYMENT: 'billing & payment',
  ADMINISTRATIVE: 'administrative',
  CLIENT_PREFERENCES: 'client preferences',
  DEMOGRAPHICS: 'demographics',
};

export const UNSUPPORTED_CATEGORIES = ['demographics'];

export const APPOINTMENT_INFO_COMPLETION_KEYS = {
  CLINICIAN: 'clinician',
  SERVICE: 'cptCode',
  LOCATION: 'office',
  DATE: 'isReserved',
};

export const PRESCREENER_COMPLETION_KEYS = {
  REASON_FOR_CARE: 'hasCompletedReasonForCare',
  BILLING_PAYMENT: 'hasCompletedBillingAndPayment',
  ADMINISTRATIVE: 'hasCompletedAdministrative',
  CLIENT_PREFERENCES: 'hasCompletedClientPreferences',
};

export const VALIDATION_MESSAGE_KEYS = {
  multiselect: {
    hint: 'booking.prescreener.validations.multiselect.hint',
    default: 'booking.prescreener.validations.multiselect.default',
  },
  string: 'booking.prescreener.validations.string',
  text: 'booking.prescreener.validations.text',
  select: 'booking.prescreener.validations.select',
  file: 'booking.prescreener.validations.file.sides',
  state: 'booking.prescreener.validations.state',
  maxLength: 'booking.prescreener.validations.maxLength',
  dateOfBirth: 'booking.prescreener.validations.dateOfBirth',
  driversLicense: 'booking.prescreener.validations.file.side',
};

export const PRESCREENER_CATEGORY_KEYS = {
  [PRESCREENER_CATEGORIES.REASON_FOR_CARE]: 'booking.prescreener.categories.reasonForCare',
  [PRESCREENER_CATEGORIES.BILLING_PAYMENT]: 'booking.prescreener.categories.billingAndPayment',
  [PRESCREENER_CATEGORIES.ADMINISTRATIVE]: 'booking.prescreener.categories.administrative',
  [PRESCREENER_CATEGORIES.CLIENT_PREFERENCES]: 'booking.prescreener.categories.clientPreferences',
  [PRESCREENER_CATEGORIES.DEMOGRAPHICS]: 'booking.prescreener.categories.demographics',
};

export const SUBTEXT_KEYS = {
  [QUESTION_NAMES.SEX]: 'booking.prescreener.questions.sex.subtext',
  [QUESTION_NAMES.STATE]: 'booking.prescreener.questions.state.subtext',
};

export const CLIENT_TYPE_KEYS = {
  client: 'booking.steps.clientTypes.individual',
  couple: 'booking.steps.clientTypes.couple',
  contact: 'booking.steps.clientTypes.contact',
};

export const DEFAULT_ATTRS = {
  maxLength: LENGTH_LIMITS.TEXT_AREA_MAX,
  isDirty: false,
};

export const DEFAULT_MAX_LENGTH_BY_TYPE = {
  [QUESTION_TYPES.STRING]: LENGTH_LIMITS.TEXT_AREA_MAX,
  [QUESTION_TYPES.TEXT]: LENGTH_LIMITS.TEXT_AREA_MAX,
};

export const APPOINTMENT_INFO_PREREQUISITE_ORDER = [
  APPOINTMENT_INFO_COMPLETION_KEYS.CLINICIAN,
  APPOINTMENT_INFO_COMPLETION_KEYS.SERVICE,
  APPOINTMENT_INFO_COMPLETION_KEYS.LOCATION,
  APPOINTMENT_INFO_COMPLETION_KEYS.DATE,
];

export const COMPLETION_KEY_TO_ROUTE = {
  [APPOINTMENT_INFO_COMPLETION_KEYS.CLINICIAN]: 'clinician',
  [APPOINTMENT_INFO_COMPLETION_KEYS.SERVICE]: 'service',
  [APPOINTMENT_INFO_COMPLETION_KEYS.LOCATION]: 'location',
  [APPOINTMENT_INFO_COMPLETION_KEYS.DATE]: 'date',
};

export const PRESCREENER_CATEGORY_TO_ROUTE = {
  [PRESCREENER_CATEGORIES.REASON_FOR_CARE]: 'prescreener-reason-for-care',
  [PRESCREENER_CATEGORIES.BILLING_PAYMENT]: 'prescreener-billing-payment',
  [PRESCREENER_CATEGORIES.ADMINISTRATIVE]: 'prescreener-administrative',
  [PRESCREENER_CATEGORIES.CLIENT_PREFERENCES]: 'prescreener-client-preferences',
  [PRESCREENER_CATEGORIES.DEMOGRAPHICS]: 'information.index',
};

const _categoryRoutes = Object.values(PRESCREENER_CATEGORY_TO_ROUTE);
export const PRESCREENER_CATEGORY_ROUTES = Object.freeze(_categoryRoutes);

const _routeToCategory = Object.entries(PRESCREENER_CATEGORY_TO_ROUTE).reduce(
  (acc, [category, route]) => {
    acc[route] = category;
    return acc;
  },
  {}
);
export const PRESCREENER_ROUTE_TO_CATEGORY = Object.freeze(_routeToCategory);

const _stepIdToCompletionKey = Object.entries(PRESCREENER_CATEGORIES).reduce(
  (acc, [key, categoryName]) => {
    const stepId = `prescreener ${categoryName}`;
    acc[stepId] = PRESCREENER_COMPLETION_KEYS[key];
    return acc;
  },
  {}
);
export const PRESCREENER_STEP_ID_TO_COMPLETION_KEY = Object.freeze(_stepIdToCompletionKey);

const _stepIdToCategoryName = Object.entries(PRESCREENER_CATEGORIES).reduce(
  (acc, [_key, categoryName]) => {
    const stepId = `prescreener ${categoryName}`;
    acc[stepId] = categoryName;
    return acc;
  },
  {}
);
export const PRESCREENER_STEP_ID_TO_CATEGORY_NAME = Object.freeze(_stepIdToCategoryName);

const _resetObject = Object.values(PRESCREENER_COMPLETION_KEYS).reduce((acc, _key) => {
  acc[_key] = false;
  return acc;
}, {});
export const PRESCREENER_RESET_OBJECT = Object.freeze(_resetObject);
